import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ct-shared-user-changed-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './user-changed-message.component.html',
})
export class UserChangedMessageComponent {
  /** Display name of the new holder - empty when the lock is gone without one */
  readonly newUser = input.required<string>();
}
